class RoleGroup {
  static NOUSCIMS = 'nouscims';
  static ENTITAT = 'entity';
  static EXTERNOS = 'foreign';
  static PUBLICO = 'public';
  static JOVEN = 'student';
  static CENTRO_EDUCATIVO = 'academy';
  static SHERPA = 'sherpa';

  constructor(private group: string) {}

  public static nouscims(): RoleGroup {
    return new RoleGroup(RoleGroup.NOUSCIMS);
  }

  public isExterno(): boolean {
    return this.group === RoleGroup.EXTERNOS;
  }

  public isSherpa(): boolean {
    return this.group === RoleGroup.SHERPA;
  }
  public value(): string {
    return this.group;
  }
}

export default RoleGroup;
